import styled from 'styled-components';
import { Table } from 'react-bootstrap';

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: ${props => getColor(props)};
    border-style: dashed;
    background-color: #fafafa;
    color: #a1a1a1;
    outline: none;
    transition: border .24s ease-in-out;
`;

export const getColor = (props) => {
    if (props.isDragAccept) {
        return '#00e676';
    }

    if (props.isDragReject) {
        return '#ff1744';
    }

    if (props.isDragActive) {
        return '#2196f3';
    }

    return '#eeeeee';
};

export const TableWrapper = styled(Table)`
    & > tbody > tr > td {
        vertical-align: middle;
    }
`;

export const FormWrapper = styled.div`
    & > .form-group {
        display: flex;
        align-items: center;
    }
`;

export const StepWrapper = styled.div`
    margin-right: 10px;
`;

export const ArrowWrapper = styled.div`
    & > .glyphicon {
        font-size: 10px;
        margin-right: 10px;
        padding-bottom: 5px;
        color: #ccc;
    }
`;

export const GridWrapper = styled.div`
    width: 100%;
    height: 400px;

    .ag-header-viewport {
        background-color: #133666;
    }
    
    .data-header {
        font-weight: bold;
        border-width: 0px 0px 0px 1px;
        border-style: solid;
        border-color: #ddd;
        
        color: white;
    }

    .data-header > div > div.ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .data-cell {
        border-width: 0px 1px 1px 1px;
        border-style: solid;
        border-color: #ddd;
        line-height: 28px;
    }

    .data-cell > .ag-react-container {
        text-align: center;
    }

    .optn-srtr-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: white;
    }

    .optn-srtr-header > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    .optn-srtr-header > .ag-react-container > div > .customHeaderLabel {
        text-align: center;
    }

    .ag-cell-inline-editing.data-cell {
        line-height: 24px;
    }

    .ag-checkbox-input-wrapper input {
        color: white;
        opacity: unset;
    }

    .ag-header-cell > .ag-header-select-all {
        margin-right: -4px;
    }

    .ag-row-odd.ag-row-selected {
        background-color: var(--ag-odd-row-background-color, #f6f6f6);
    }

    .ag-row-even.ag-row-selected {
        background-color: var(--ag-background-color, #FFF);
    }
`;